import React from 'react';
import './Chapters.scss';

function Chapter1() {
  return (
    <>
      <section className="chapter">
        <h2 className="chapter__introtitle" style={{ fontSize: '24px', lineHeight: '34px' }}>
          As the largest chemical producer in the world, BASF is creating chemistry for a shiny, new
          future.
        </h2>

        <p className="chapter__paragraph">
          Cars are an emotional purchase. People want the car they drive to reflect more than the
          mundanities of their lifestyles; they want it to be a symbol of their values. That desire
          is apparent in the way modern vehicle design has evolved. Now, more than ever, consumers
          are seeking radical designs that represent an optimistic and sustainable future. Every
          element of a car’s design then becomes an opportunity to express these ideals — with paint
          color being no exception. That’s why German chemical producer BASF is leading the charge
          for the next generation of innovative automotive paints.
        </p>
        <p className="chapter__paragraph">
          BASF’s Coatings division is a global supplier of automotive paint, providing surface
          treatments for the{' '}
          <a
            href="https://refinish.basf.us/business-services/oem/oem-approvals/"
            target="_blank"
            rel="sponsored"
          >
            world’s leading manufacturers.
          </a>{' '}
          In fact, about 50% of cars produced each year have at least one coating layer from BASF.
          To ensure that they are at the forefront of the industry, BASF’s team of automotive trend
          forecasters release a yearly report that explores what consumers want next, and a color
          collection that inspires designers around the globe to stretch their imaginations and push
          themselves into new creative spaces.
        </p>
      </section>
    </>
  );
}

export default Chapter1;
